import {Input} from 'antd';

const AppInputField = ({...others}) => {
  return <Input size='large' {...others} />;
};

export default AppInputField;
